import { render, staticRenderFns } from "./NoteDropdown.vue?vue&type=template&id=0db1b040&scoped=true"
import script from "./NoteDropdown.vue?vue&type=script&lang=js"
export * from "./NoteDropdown.vue?vue&type=script&lang=js"
import style0 from "./NoteDropdown.vue?vue&type=style&index=0&id=0db1b040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1b040",
  null
  
)

export default component.exports